// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3983f80","455":"ff077e70","946":"e0ca780e"}[chunkId] + ".chunk.js";
};